import React, { useEffect } from 'react';
import { Download } from 'lucide-react';
import './landing/landing.css';

const APK = '/download/ShiftReady-test.apk';

const STEPS = [
  'Tap the yellow button. If Chrome says "File might be harmful", tap Download anyway.',
  'When the download finishes, tap Open.',
  'If Android blocks it, tap Settings → turn on "Allow from this source" → go back.',
  'Tap Install. If Play Protect warns you, tap Install anyway.',
  'Open ShiftReady from your home screen.',
];

// Private, unlinked page for installing the Android test build. Remove before public launch.
export default function AndroidTestDownload() {
  useEffect(() => {
    document.title = 'ShiftReady — Android test download';
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);

  return (
    <div className="lp lp-getapp" data-testid="android-test-page">
      <main className="lp-wrap lp-getapp__inner">
        <a href="/" className="lp-brand"><img src="/landing/icon.webp" alt="" width="40" height="40" /><span>ShiftReady</span></a>
        <h1 className="lp-h1">Install the <em>Android test app.</em></h1>
        <p className="lp-lead">For testing only. Open this page in Chrome on your Android phone, on Wi-Fi (about 72 MB).</p>
        <a href={APK} download="ShiftReady-test.apk" className="lp-pv__cta" style={{ fontSize: 18, padding: '20px 28px', '--navy': '#0a1f44', '--yellow': '#f7c948', background: 'var(--yellow)' }} data-testid="android-test-download-btn">
          <Download size={22} /> Download ShiftReady
        </a>
        <ol className="lp-lead" style={{ marginTop: 36, paddingLeft: 22, display: 'grid', gap: 10, fontSize: 16, listStyle: 'decimal' }} data-testid="android-test-steps">
          {STEPS.map((s) => <li key={s}>{s}</li>)}
        </ol>
      </main>
    </div>
  );
}
